import { render, staticRenderFns } from "./BagsTitle.vue?vue&type=template&id=5193bd5c&scoped=true"
import script from "./BagsTitle.vue?vue&type=script&lang=js"
export * from "./BagsTitle.vue?vue&type=script&lang=js"
import style0 from "./BagsTitle.vue?vue&type=style&index=0&id=5193bd5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5193bd5c",
  null
  
)

export default component.exports